import { render, staticRenderFns } from "./MarkedText.vue?vue&type=template&id=3be7ab00&scoped=true&"
import script from "./MarkedText.vue?vue&type=script&lang=js&"
export * from "./MarkedText.vue?vue&type=script&lang=js&"
import style0 from "./MarkedText.vue?vue&type=style&index=0&id=3be7ab00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be7ab00",
  null
  
)

export default component.exports